// No axios import; duck-type the shape to stay runtime-safe
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function beforeSendAddAxiosContext(event: any, hint: any) {
  addAxiosContextRecursive(event, hint?.originalException)
  return event
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function addAxiosContextRecursive(event: any, error: any) {
  if (!error || typeof error !== 'object') return

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const maybeAxios = error as any
  // axios sets isAxiosError = true; response is a plain object in both node & browser
  if (maybeAxios.isAxiosError && maybeAxios.response) {
    event.contexts = {
      ...event.contexts,
      Axios: { Response: maybeAxios.response },
    }
    return
  }
  if (maybeAxios.cause) addAxiosContextRecursive(event, maybeAxios.cause)
}
